module.exports = __webpack_public_path__ + "static/img/noresult.6582c3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/noresult.jpg
// module id = VQVt
// module chunks = 4